import { useQuery } from '@tanstack/react-query';
import { Route } from '../../../routes/category.$';
import { categoryShowQuery } from '../../../lib/queries';
import { ArticleCard } from '../../home/components/ArticleCard';
import { CategoryBreadcrumbs } from '../components/CategoryBreadcrumbs';
import { Pagination } from '../components/Pagination';

export function CategoryShowPage() {
  const params = Route.useParams();
  const slug = params._splat ?? '';
  const page = Route.useSearch().page ?? 1;
  const { data, isLoading, isError } = useQuery({
    ...categoryShowQuery(slug, page),
    enabled: slug.length > 0,
  });

  if (isError) {
    return <CategoryStatus message="تعذر تحميل التصنيف حالياً." />;
  }

  if (isLoading || !data) {
    return <CategoryStatus message="جاري تحميل التصنيف..." />;
  }

  return (
    <section className="about-item-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <CategoryBreadcrumbs chain={data.category.parentChain} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            {/* Category listings shipped without an h1, so the only on-page
                statement of the topic was the <title>. */}
            <h1 className="title mt-4 mb-0">
              {data.category.name}
              {page > 1 ? ` — صفحة ${page}` : ''}
            </h1>
            <div className="about-tab-btn mt-4">
              <div className="about-post-items">
                {data.articles.length === 0 ? (
                  <div
                    className="text-center py-5"
                    style={{
                      padding: '48px 16px',
                      color: '#6c757d',
                      fontSize: 14,
                      border: '1px dashed #dee2e6',
                      borderRadius: 8,
                      background: '#f8f9fa',
                    }}
                  >
                    لا توجد مقالات في هذا التصنيف بعد.
                  </div>
                ) : (
                  <>
                    <div className="row">
                      {data.articles.map((a) => (
                        <div className="col-lg-4 col-md-4" key={a.id}>
                          <ArticleCard card={a} />
                        </div>
                      ))}
                    </div>
                    <div className="row mt-4">
                      <div className="col-lg-12">
                        <Pagination
                          slug={data.category.slug}
                          page={data.pagination.page}
                          totalPages={data.pagination.totalPages}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function CategoryStatus({ message }: { message: string }) {
  return (
    <section className="about-item-area">
      <div className="container">
        <div className="about-tab-btn mt-4">
          <div className="about-post-items">
            <div
              className="text-center py-5"
              style={{
                padding: '48px 16px',
                color: '#6c757d',
                fontSize: 14,
                border: '1px dashed #dee2e6',
                borderRadius: 8,
                background: '#f8f9fa',
              }}
            >
              {message}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
